import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateService } from 'outshared-lib';
import { Injectable, Injector } from '@angular/core';

@Injectable()
export class CynoDateParserFormatter extends NgbDateParserFormatter {
    private dateService: DateService;

    constructor() {
        super();
        const injector = Injector.create({providers: [{provide: DateService, deps: []}]});
        this.dateService = injector.get(DateService);
    }

    public format(date: NgbDate): string {
        if (!date) {
            return '';
        }
        const dateStruct = {year: date.year, month: date.month, day: date.day};
        return this.dateService.isValid(dateStruct) ? this.dateService.format(dateStruct, 'DD-MM-YYYY') : '';
    }

    public parse(value: string): NgbDate {
        if (!this.dateService.isValid(value)) {
            return null;
        }
        const dateStruct = this.dateService.toNgbDateStruct(value);
        return new NgbDate(dateStruct.year, dateStruct.month, dateStruct.day);
    }
}
